import { useCallback } from 'react';
import useError, { reportError } from 'src/screens/error/useError';

/**
 * Custom hook to handle API errors consistently
 * Replaces the repetitive pattern: .catch((e) => setError(reportError(e)))
 * 
 * @returns A function that handles API errors by reporting them to Sentry and Redux
 */
export const useApiErrorHandler = () => {
  const { setError } = useError();

  const handleError = useCallback(
    (error: any) => {
      setError(reportError(error));
    },
    [setError]
  );

  return handleError;
};
